(function () {
  'use strict';

  var STATE_VERSION = 'lilith-enterprise-v4';
  var D2R = Math.PI / 180;

  function initAll(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    var roots = parent.querySelectorAll('[data-lsc-v2]');
    for (var i = 0; i < roots.length; i += 1) init(roots[i]);
  }

  function init(root) {
    if (!root || root.getAttribute('data-lsc-ready') === 'true') return;
    root.setAttribute('data-lsc-ready', 'true');

    var locale = String(root.getAttribute('data-locale') || document.documentElement.lang || 'en').toLowerCase();
    var copyNode = root.querySelector('[data-lsc-copy]');
    var assetNode = root.querySelector('[data-lsc-assets]');
    var copy;
    var assets;
    try { copy = JSON.parse(copyNode ? copyNode.textContent : '{}'); } catch (_) { copy = {}; }
    try { assets = JSON.parse(assetNode ? assetNode.textContent : '{}'); } catch (_) { assets = {}; }
    if (!copy.signs || !copy.signs.length || !copy.houses || !copy.lenses) return;

    function q(name) { return root.querySelector('[data-lsc-' + name + ']'); }
    function qa(name) { return root.querySelectorAll('[data-lsc-' + name + ']'); }
    function clean(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim(); }
    function fill(template, values) {
      return String(template || '').replace(/\{([a-z]+)\}/gi, function (_, key) {
        return Object.prototype.hasOwnProperty.call(values || {}, key) ? String(values[key]) : '';
      });
    }
    function make(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text != null) node.textContent = text;
      return node;
    }
    function clear(node) { while (node && node.firstChild) node.removeChild(node.firstChild); }
    function scrollTo(node) {
      if (!node) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { node.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (_) { node.scrollIntoView(); }
    }
    function track(eventName, params) {
      var payload = params || {};
      payload.tool = 'lilith-sign-calculator';
      payload.funnel_version = 'enterprise-v3';
      try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (_) {}
      try { if (typeof window.clarity === 'function') window.clarity('event', eventName); } catch (_) {}
    }

    var form = q('form');
    var result = q('result');
    var dateInput = q('date');
    var timeInput = q('time');
    var cityInput = q('city');
    var suggestions = q('suggestions');
    var calculateButton = q('calculate');
    var againButton = q('again');
    var reflectButton = q('reflect');
    var editButton = q('edit');
    var reflectionPaidButton = q('reflection-paid');
    var mobileBuy = q('mobile-buy');
    var mobileBuyButton = q('mobile-buy-button');
    var lensButtons = qa('lens');
    var selectedPlace = null;
    var currentChart = null;
    var selectedLens = 'desire';
    var currentReflection = null;
    var stateKey = 'deckaura:lilith:v4:' + locale;
    var cityTimer = null;
    var lastCityQuery = '';
    var offerObserver = null;
    var offerNoteSet = '';
    var offerTimer = null;
    var mobileOfferObserver = null;
    var mobileOfferVisible = false;
    var mobileRevealVisible = false;
    var mobileBuyLabel = mobileBuyButton ? mobileBuyButton.textContent : '';
    var mobileBusyTimer = null;
    var cartReviewHost = q('cart-review');
    var offerNode = q('offer');
    var lensSection = root.querySelector('.lsc-v2__lens');

    /* Keep the complete free experience before the paid decision in the runtime
       reading order, including on translated templates that share this section. */
    if (offerNode && lensSection && lensSection.nextElementSibling !== offerNode) {
      lensSection.insertAdjacentElement('afterend', offerNode);
    }

    /* This page intentionally suppresses the two-item site-wide marquee. The
       result offer carries its own calmer, page-scoped proof surface. */
    var pageMarquees = document.querySelectorAll('.da-review-marquee');
    for (var marqueeIndex = 0; marqueeIndex < pageMarquees.length; marqueeIndex += 1) {
      pageMarquees[marqueeIndex].hidden = true;
      pageMarquees[marqueeIndex].setAttribute('aria-hidden', 'true');
    }

    function norm(value) {
      value %= 360;
      return value < 0 ? value + 360 : value;
    }
    function julianDay(year, month, day, universalHours) {
      if (month <= 2) { year -= 1; month += 12; }
      var a = Math.floor(year / 100);
      var b = 2 - a + Math.floor(a / 4);
      return Math.floor(365.25 * (year + 4716)) + Math.floor(30.6001 * (month + 1)) + day + b - 1524.5 + universalHours / 24;
    }
    function meanLilith(jd) {
      var t = (jd - 2451545.0) / 36525;
      var perigee = 83.3532465 + 4069.0137287 * t - 0.0103200 * t * t - t * t * t / 80053 + t * t * t * t / 18999000;
      return norm(perigee + 180);
    }
    /* Keep the verified ascendant formula used by the live calculator. */
    function ascendant(jd, latitude, eastLongitude) {
      var t = (jd - 2451545.0) / 36525;
      var gmst = norm(280.46061837 + 360.98564736629 * (jd - 2451545.0) + 0.000387933 * t * t);
      var ramc = norm(gmst + eastLongitude) * D2R;
      var epsilon = (23.4392911 - 0.0130042 * t) * D2R;
      var phi = latitude * D2R;
      return norm(Math.atan2(Math.cos(ramc), -(Math.sin(ramc) * Math.cos(epsilon) + Math.tan(phi) * Math.sin(epsilon))) / D2R);
    }
    function timezoneOffsetHours(timezone, year, month, day, hour, minute) {
      try {
        var guess = Date.UTC(year, month - 1, day, hour, minute);
        var offset = null;
        for (var i = 0; i < 2; i += 1) {
          var parts = new Intl.DateTimeFormat('en-US', { timeZone: timezone, timeZoneName: 'longOffset' }).formatToParts(new Date(guess));
          var zonePart = null;
          for (var p = 0; p < parts.length; p += 1) if (parts[p].type === 'timeZoneName') zonePart = parts[p];
          var match = String(zonePart ? zonePart.value : '').match(/GMT([+-])(\d{2}):(\d{2})/);
          if (!match) return zonePart && zonePart.value === 'GMT' ? 0 : null;
          offset = (match[1] === '-' ? -1 : 1) * (parseInt(match[2], 10) + parseInt(match[3], 10) / 60);
          guess = Date.UTC(year, month - 1, day, hour, minute) - offset * 3600000;
        }
        return offset;
      } catch (_) { return null; }
    }
    function signAt(longitude) { return copy.signs[Math.floor(norm(longitude) / 30) % 12]; }
    function degreeWithinSign(longitude) { return norm(longitude) % 30; }
    function formattedDegree(longitude) {
      var sign = signAt(longitude);
      var raw = degreeWithinSign(longitude);
      var degree = Math.floor(raw);
      /* Keep the displayed degree in the same canonical sign as the card/result. */
      var minute = Math.min(59, Math.round((raw - degree) * 60));
      return degree + '°' + (minute < 10 ? '0' : '') + minute + '′ ' + sign.name;
    }
    function validDateParts(value) {
      var parts = String(value || '').split('-');
      if (parts.length !== 3) return null;
      var parsed = { y: Number(parts[0]), m: Number(parts[1]), d: Number(parts[2]) };
      if (parsed.y < 1920) return null;
      var probe = new Date(parsed.y, parsed.m - 1, parsed.d);
      if (!parsed.y || probe.getFullYear() !== parsed.y || probe.getMonth() !== parsed.m - 1 || probe.getDate() !== parsed.d) return null;
      return parsed;
    }
    function isFutureDate(parts) {
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return new Date(parts.y, parts.m - 1, parts.d) > today;
    }
    function localizedDate(value) {
      var parts = validDateParts(value);
      if (!parts) return clean(value);
      try {
        return new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' })
          .format(new Date(Date.UTC(parts.y, parts.m - 1, parts.d)));
      } catch (_) { return clean(value); }
    }
    function chartInputSummary(chart) {
      var pieces = [localizedDate(chart.date)];
      if (chart.time) pieces.push(chart.time);
      if (chart.place) pieces.push(chart.place.name + (chart.place.region ? ', ' + chart.place.region : ''));
      return pieces.join(' · ');
    }
    function setFormComplete(chart) {
      var summary = q('input-summary');
      var summaryText = q('input-summary-text');
      if (summaryText) summaryText.textContent = chartInputSummary(chart);
      if (summary) summary.hidden = false;
      if (form) form.classList.add('is-complete');
    }
    function restoreFormForEditing(hideResult) {
      var summary = q('input-summary');
      if (summary) summary.hidden = true;
      if (form) {
        form.hidden = false;
        form.classList.remove('is-complete');
      }
      if (hideResult && result) result.hidden = true;
      try { if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.hide === 'function') window.DeckauraDeepReading.hide(); } catch (_) {}
    }

    function closeSuggestions() {
      if (!suggestions) return;
      suggestions.classList.remove('is-open');
      clear(suggestions);
      if (cityInput) cityInput.setAttribute('aria-expanded', 'false');
    }
    function chooseCity(item) {
      selectedPlace = {
        name: clean(item.name),
        region: clean([item.admin1, item.country].filter(Boolean).join(', ')),
        lat: Number(item.latitude),
        lon: Number(item.longitude),
        tz: clean(item.timezone || '')
      };
      cityInput.value = selectedPlace.name + (selectedPlace.region ? ', ' + selectedPlace.region : '');
      cityInput.removeAttribute('aria-invalid');
      if (q('city-error')) q('city-error').textContent = '';
      closeSuggestions();
      syncTimeCityRequirement();
      track('lilith_city_selected', { has_city: 1 });
    }
    function searchCity() {
      var query = clean(cityInput.value);
      lastCityQuery = query;
      if (query.length < 2) { closeSuggestions(); return; }
      var language = String(root.getAttribute('data-content-locale') || 'en').split('-')[0];
      fetch('https://geocoding-api.open-meteo.com/v1/search?count=6&format=json&language=' + encodeURIComponent(language) + '&name=' + encodeURIComponent(query))
        .then(function (response) { if (!response.ok) throw new Error('city'); return response.json(); })
        .then(function (data) {
          if (query !== lastCityQuery) return;
          var rows = data && Array.isArray(data.results) ? data.results : [];
          clear(suggestions);
          if (!rows.length) { closeSuggestions(); return; }
          for (var i = 0; i < rows.length; i += 1) {
            (function (item) {
              var button = make('button', '', '');
              button.type = 'button';
              button.setAttribute('role', 'option');
              button.setAttribute('aria-selected', 'false');
              button.appendChild(make('span', '', clean(item.name)));
              button.appendChild(make('small', '', clean([item.admin1, item.country].filter(Boolean).join(', '))));
              button.addEventListener('click', function () { chooseCity(item); });
              suggestions.appendChild(button);
            }(rows[i]));
          }
          suggestions.classList.add('is-open');
          cityInput.setAttribute('aria-expanded', 'true');
        })
        .catch(function () { closeSuggestions(); });
    }

    function hash(value) {
      var h = 2166136261;
      var input = String(value || '');
      for (var i = 0; i < input.length; i += 1) {
        h ^= input.charCodeAt(i);
        h = Math.imul(h, 16777619);
      }
      return (h >>> 0).toString(36);
    }
    function syncTimeCityRequirement() {
      if (!cityInput || !timeInput) return;
      cityInput.setAttribute('aria-required', String(!!clean(timeInput.value)));
    }
    function saveSession() {
      if (!currentChart) return;
      try {
        window.sessionStorage.setItem(stateKey, JSON.stringify({
          version: STATE_VERSION,
          savedAt: Date.now(),
          date: currentChart.date,
          time: currentChart.time,
          city: cityInput ? clean(cityInput.value) : '',
          place: currentChart.place,
          lens: selectedLens,
          reflection: currentReflection
        }));
      } catch (_) {}
    }
    function clearSession() {
      try { window.sessionStorage.removeItem(stateKey); } catch (_) {}
    }
    function restoreSession() {
      var saved;
      try { saved = JSON.parse(window.sessionStorage.getItem(stateKey) || 'null'); } catch (_) { saved = null; }
      if (!saved || saved.version !== STATE_VERSION || !validDateParts(saved.date)) return false;
      dateInput.value = saved.date;
      /* keep the visible numeric date parts (international-date-inputs.js) in step with the restored value */
      var restoredParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(saved.date);
      if (restoredParts && dateInput.id) [['Year', 1], ['Month', 2], ['Day', 3]].forEach(function (part) {
        var field = document.getElementById(dateInput.id + part[0]);
        if (field) field.value = restoredParts[part[1]];
      });
      timeInput.value = clean(saved.time);
      cityInput.value = clean(saved.city);
      if (q('more') && (clean(saved.time) || clean(saved.city))) q('more').open = true;
      var place = saved.place;
      if (place && clean(place.name) && Number.isFinite(Number(place.lat)) && Number.isFinite(Number(place.lon)) && clean(place.tz)) {
        selectedPlace = {
          name: clean(place.name),
          region: clean(place.region),
          lat: Number(place.lat),
          lon: Number(place.lon),
          tz: clean(place.tz)
        };
      } else selectedPlace = null;
      selectedLens = copy.lenses[saved.lens] ? saved.lens : 'desire';
      currentReflection = saved.reflection && saved.reflection.lens === selectedLens ? saved.reflection : null;
      syncTimeCityRequirement();
      calculate(true);
      if (currentChart && currentReflection) renderReflection(currentReflection, true, true);
      return !!currentChart;
    }

    function uncertaintyText(chart) {
      var within = degreeWithinSign(chart.mean);
      var cusp = Math.min(within, 30 - within) <= 0.25;
      if (!chart.hasTime && cusp) return copy.uncertaintyNoonCusp;
      if (!chart.hasTime) return copy.uncertaintyNoon;
      if (cusp) return copy.uncertaintyTimedCusp;
      return copy.uncertaintyTimed;
    }
    function renderBase(chart, restoring) {
      q('sign').textContent = chart.sign.name;
      q('glyph').textContent = chart.sign.glyph;
      q('degree').textContent = chart.hasTime ? copy.degreeTimed : copy.degreeNoon;
      q('mean').textContent = formattedDegree(chart.mean);
      q('house').textContent = chart.houseIndex >= 0 ? copy.houses[chart.houseIndex].title : (chart.hasTime ? copy.selectCity : copy.addTime);
      q('rising').textContent = chart.risingIndex >= 0 ? copy.signs[chart.risingIndex].name : (chart.hasTime ? copy.selectCity : copy.addTime);
      q('uncertainty').textContent = uncertaintyText(chart) + (chart.timeIgnored ? ' ' + (root.getAttribute('data-time-no-city') || '') : '');
      q('interpretation-title').textContent = fill(copy.interpretationTitle, { sign: chart.sign.name });
      q('interpretation').textContent = chart.sign.summary;
      q('archetype').textContent = chart.sign.archetype;
      var image = q('result-image');
      var back = q('card-back');
      var stage = q('card-stage');
      var status = q('card-status');
      if (image) {
        image.alt = fill(copy.cardAlt, { sign: chart.sign.name, archetype: chart.sign.archetype });
        if (stage) stage.classList.remove('is-front');
        if (back && !back.getAttribute('src')) back.src = back.getAttribute('data-src') || '';
        if (status) status.textContent = fill(copy.revealingCard, { sign: chart.sign.name });
        image.src = assets[chart.sign.key] || '';
      }
      /* The house interpretation belongs to the written reading; the house title stays in the facts. */
      q('house-copy').hidden = true;
      setFormComplete(chart);
      if (result) result.hidden = false;
      if (!restoring) {
        selectedLens = 'desire';
        currentReflection = null;
      }
      for (var i = 0; i < lensButtons.length; i += 1) {
        var selected = lensButtons[i].getAttribute('data-lsc-lens') === selectedLens;
        lensButtons[i].setAttribute('aria-checked', String(selected));
        lensButtons[i].tabIndex = selected ? 0 : -1;
      }
      q('lens-error').textContent = '';
      q('reflection').hidden = true;
      enableOffer(chart, selectedLens);
      decorateOfferSoon();
      if (!restoring) scrollTo(result);
      function finishReveal() {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(function () {
          if (stage) stage.classList.add('is-front');
          if (status) status.textContent = fill(copy.revealedCard, { sign: chart.sign.name, archetype: chart.sign.archetype });
          window.setTimeout(function () {
            if (restoring) return;
            var heading = q('sign');
            if (!heading) return;
            try { heading.focus({ preventScroll: true }); } catch (_) { heading.focus(); }
          }, reduce ? 0 : 640);
        }, reduce ? 0 : 260);
      }
      if (image && typeof image.decode === 'function') image.decode().then(finishReveal).catch(finishReveal);
      else if (image && !image.complete) image.addEventListener('load', finishReveal, { once: true });
      else finishReveal();
      if (!restoring) track('lilith_placement_viewed', { sign: chart.sign.key.toLowerCase(), has_house: chart.houseIndex >= 0 ? 1 : 0, confidence: chart.hasTime ? 'timed_mean_estimate' : 'date_only_noon_estimate' });
      saveSession();
    }
    function calculate(restoring) {
      var dateParts = validDateParts(dateInput.value);
      var future = !!(dateInput.validity && dateInput.validity.rangeOverflow) || !!(dateParts && isFutureDate(dateParts));
      if (!dateParts || future) {
        dateInput.setAttribute('aria-invalid', 'true');
        q('date-error').textContent = future ? copy.dateFuture : copy.dateRequired;
        dateInput.focus();
        return;
      }
      dateInput.removeAttribute('aria-invalid');
      q('date-error').textContent = '';
      /* House and rising need both a time and a city picked from the list. Without the pair,
         calculate the date-only placement and say so in the result instead of blocking. */
      var hasTime = !!clean(timeInput.value) && !!selectedPlace;
      var timeIgnored = !!clean(timeInput.value) && !selectedPlace;
      if (cityInput) cityInput.removeAttribute('aria-invalid');
      if (q('city-error')) q('city-error').textContent = '';
      var timeParts = String(timeInput.value || '12:00').split(':');
      var hour = Number(timeParts[0]) || 0;
      var minute = Number(timeParts[1]) || 0;
      var offset = hasTime && selectedPlace && selectedPlace.tz ? timezoneOffsetHours(selectedPlace.tz, dateParts.y, dateParts.m, dateParts.d, hour, minute) : null;
      if (!hasTime) offset = 0;
      if (hasTime && selectedPlace && offset === null) {
        cityInput.setAttribute('aria-invalid', 'true');
        q('city-error').textContent = copy.timezoneResolveFailed;
        cityInput.focus();
        return;
      }
      var jd = julianDay(dateParts.y, dateParts.m, dateParts.d, hour + minute / 60 - offset);
      var mean = meanLilith(jd);
      var sign = signAt(mean);
      var risingIndex = -1;
      var houseIndex = -1;
      if (hasTime && selectedPlace) {
        var risingLongitude = ascendant(jd, selectedPlace.lat, selectedPlace.lon);
        risingIndex = Math.floor(risingLongitude / 30) % 12;
        houseIndex = (copy.signs.indexOf(sign) - risingIndex + 12) % 12;
      }
      currentChart = {
        date: dateInput.value,
        time: hasTime ? timeInput.value : '',
        hasTime: hasTime,
        mean: mean,
        sign: sign,
        risingIndex: risingIndex,
        houseIndex: houseIndex,
        timeIgnored: timeIgnored,
        place: hasTime ? selectedPlace : null,
        jd: jd
      };
      renderBase(currentChart, !!restoring);
    }

    function buildReflection(chart, lensKey) {
      var lens = copy.lenses[lensKey];
      if (!lens) throw new Error('lens');
      return {
        lens: lensKey,
        title: fill(lens.title, { sign: chart.sign.name }),
        body: fill(lens.body, { sign: chart.sign.name, theme: chart.sign.theme }),
        notice: fill(lens.notice, { sign: chart.sign.name, theme: chart.sign.theme }),
        step: fill(lens.step, { sign: chart.sign.name, theme: chart.sign.theme })
      };
    }
    function renderReflection(reflection, restored, suppressScroll) {
      currentReflection = reflection;
      q('reflection-title').textContent = reflection.title;
      q('reflection-body').textContent = reflection.body;
      q('notice-label').textContent = copy.noticeLabel;
      q('step-label').textContent = copy.stepLabel;
      q('reflection-notice').textContent = reflection.notice;
      q('reflection-step').textContent = reflection.step;
      q('reflection').hidden = false;
      q('lens-error').textContent = restored ? copy.restored : '';
      if (!suppressScroll) scrollTo(q('reflection'));
      enableOffer(currentChart, reflection.lens);
      decorateOfferSoon();
      saveSession();
    }
    function createReflection() {
      if (!currentChart) return;
      if (!selectedLens) {
        q('lens-error').textContent = copy.chooseLens;
        if (lensButtons.length) lensButtons[0].focus();
        return;
      }
      try {
        var reflection = buildReflection(currentChart, selectedLens);
        renderReflection(reflection, false);
        track('lilith_reflection_created', { lens: selectedLens, sign: currentChart.sign.key.toLowerCase(), access: 'unlimited' });
      } catch (_) {
        q('lens-error').textContent = copy.reflectionError;
      }
    }

    function offerSignals(chart, lensKey) {
      var signals = [
        { label: copy.meanLabel || 'Mean Lilith', value: formattedDegree(chart.mean) },
        { label: copy.houseLabel || 'Whole Sign house', value: chart.houseIndex >= 0 ? copy.houses[chart.houseIndex].title : copy.notCalculated },
        { label: copy.risingLabel || 'Rising sign', value: chart.risingIndex >= 0 ? copy.signs[chart.risingIndex].name : copy.notCalculated }
      ];
      if (lensKey && copy.lenses[lensKey]) signals.push({ label: copy.lensLabel || 'Selected lens', value: copy.lenses[lensKey].label });
      if (chart.place) signals.push({ label: copy.placeLabel || 'Birth place', value: chart.place.name + (chart.place.region ? ', ' + chart.place.region : '') });
      return signals;
    }
    function offerContext(chart, lensKey) {
      var lens = lensKey && copy.lenses[lensKey] ? copy.lenses[lensKey].label : copy.noLens;
      return [
        'Mean Black Moon Lilith: ' + formattedDegree(chart.mean) + '.',
        'Canonical zodiac card: ' + chart.sign.archetype + '.',
        chart.houseIndex >= 0 ? 'Whole Sign house: ' + copy.houses[chart.houseIndex].title + '; rising sign: ' + copy.signs[chart.risingIndex].name + '.' : 'House and rising sign not calculated.',
        'Selected interpretation lens: ' + lens + '.',
        'Use the supplied Mean Lilith placement only. Treat astrology as reflective guidance, not certainty.'
      ].join(' ');
    }
    function enableOffer(chart, lensKey) {
      var attempts = 0;
      function run() {
        attempts += 1;
        if (!window.DeckauraDeepReading || typeof window.DeckauraDeepReading.enable !== 'function') {
          if (attempts < 60) window.setTimeout(run, 100);
          return;
        }
        var signals = offerSignals(chart, lensKey);
        var lens = lensKey && copy.lenses[lensKey] ? copy.lenses[lensKey] : null;
        try {
          window.DeckauraDeepReading.enable({
            type: 'Black Moon Lilith',
            tool: '/pages/lilith-sign-calculator · Mean Lilith sign, degree and Whole Sign house',
            context: offerContext(chart, lensKey),
            question: lens ? fill(copy.offerQuestion, { lens: lens.label, sign: chart.sign.name }) : fill(copy.offerQuestionBase, { sign: chart.sign.name }),
            focus: lens ? lens.label : '',
            signals: signals,
            scope: 'Use only the supplied Mean Black Moon Lilith placement and Whole Sign house data. The mean position is an astronomical approximation and astrology is interpretive. Never invent unsupplied positions, aspects or missing houses.',
            confidence: chart.hasTime && chart.houseIndex >= 0 ? 'Timed Mean Lilith estimate with selected city and calculated Whole Sign house.' : 'Mean Lilith date estimate; no house or rising sign without exact time and selected city.',
            resultSelector: '#lsc-v2-' + root.id.replace(/^lsc-v2-/, '') + ' [data-lsc-result]',
            readingId: 'lsc-' + hash([
              chart.date, chart.time || 'noon', Number(chart.jd).toFixed(8),
              chart.place ? chart.place.name + ':' + chart.place.lat + ':' + chart.place.lon : 'no-place',
              chart.sign.key, lensKey || 'base'
            ].join('|')),
            curiosityQuestion: lens ? fill(copy.curiosityLens, { lens: lens.label, sign: chart.sign.name }) : fill(copy.curiosityBase, { sign: chart.sign.name }),
            lang: locale,
            resultReady: true,
            requireContext: false,
            defaultTier: 'deeper',
            singlePrimary: false,
            teaser: false,
            presentationVariant: 'lilith-enterprise-v3-direct-packages',
            analyticsTopic: lens ? 'self' : 'general',
            /* A saved reading already in the cart: show the keep/replace choice under the
               package button, also when checkout was started from the sticky bar. */
            checkoutRecoveryHost: cartReviewHost,
            onCartReviewReady: function (host) {
              setMobileBusy(false);
              revealNode(host);
              try { host.focus({ preventScroll: true }); } catch (_) {}
            },
            checkoutProperties: function () {
              var house = chart.houseIndex >= 0 ? copy.houses[chart.houseIndex].title : copy.notCalculated;
              var rising = chart.risingIndex >= 0 ? copy.signs[chart.risingIndex].name : copy.notCalculated;
              var properties = {};
              properties[copy.checkoutPlacement || 'Your Lilith placement'] = formattedDegree(chart.mean) + ' · ' + (copy.houseLabel || 'Whole Sign house') + ': ' + house + ' · ' + (copy.risingLabel || 'Rising sign') + ': ' + rising;
              properties[copy.checkoutLens || 'Chosen lens'] = lens ? lens.label : copy.noLens;
              properties._lilith_system = 'Mean Black Moon Lilith';
              properties._lilith_sign = chart.sign.name;
              properties._lilith_degree = formattedDegree(chart.mean);
              properties._lilith_house = house;
              properties._lilith_rising = rising;
              properties._lilith_lens = lens ? lens.label : copy.noLens;
              return properties;
            }
          });
          if (window.DeckauraDeepReading.setTier) window.DeckauraDeepReading.setTier('deeper', 'lsc_result');
          decorateOfferSoon();
        } catch (_) {}
      }
      run();
    }
    function setText(node, text) { if (node && clean(node.textContent) !== clean(text)) node.textContent = text; }
    function updateMobileBuy(gate) {
      if (!mobileBuy) return;
      // The rail disables the package cards while checkout opens; keep the bar and its progress label.
      if (!mobileBuy.hidden && mobileBuyButton && mobileBuyButton.getAttribute('aria-busy') === 'true') return;
      var compact = window.matchMedia && window.matchMedia('(max-width: 720px)').matches;
      var selected = gate && (gate.querySelector('.ddr-gate__price.is-selected:not([disabled])') || gate.querySelector('.ddr-gate__price[data-tier="deeper"]:not([disabled])'));
      var tier = selected && selected.querySelector('small');
      var price = selected && selected.querySelector('strong');
      setText(q('mobile-tier'), tier ? clean(tier.textContent) : '');
      setText(q('mobile-price'), price ? clean(price.textContent) : '');
      /* The bar can be tapped before the lens picker is reached: name the focus the reading will use. */
      var focusNode = q('mobile-focus');
      var lensLabel = selectedLens && copy.lenses[selectedLens] ? copy.lenses[selectedLens].label : '';
      if (focusNode) {
        setText(focusNode, lensLabel ? fill(root.getAttribute('data-mobile-focus') || '{lens}', { lens: lensLabel }) : '');
        focusNode.hidden = !lensLabel;
      }
      mobileBuy.hidden = !(compact && mobileOfferVisible && !mobileRevealVisible && selected && price && clean(price.textContent) && clean(price.textContent) !== '—');
    }
    function decorateOffer() {
      offerTimer = null;
      var gate = root.querySelector('#ddrGate');
      var cta = root.querySelector('#ddrCta');
      var offer = q('offer');
      if (!gate && !cta) return;
      if (offerObserver) offerObserver.disconnect();
      if (gate) {
        gate.classList.add('lsc-offer-v2');
        gate.setAttribute('data-lsc-offer-version', 'enterprise-v3');
        setText(gate.querySelector('.ddr-gate__eyebrow'), root.getAttribute('data-offer-eyebrow'));
        setText(gate.querySelector('.ddr-gate__title'), root.getAttribute('data-offer-title'));
        setText(gate.querySelector('.ddr-gate__lead'), root.getAttribute('data-offer-lead'));
        setText(gate.querySelector('#ddrGateDepthHeading,.ddr-gate__depth-heading'), root.getAttribute('data-offer-depth'));
        setText(gate.querySelector('.ddr-gate__promise-kicker'), copy.offerPromiseKicker);
        setText(gate.querySelector('.ddr-gate__promise-question'), selectedLens && copy.lenses[selectedLens]
          ? fill(copy.offerPromiseQuestion, { sign: currentChart ? currentChart.sign.name : '', lens: copy.lenses[selectedLens].label })
          : fill(copy.curiosityBase, { sign: currentChart ? currentChart.sign.name : '' }));
        setText(gate.querySelector('.ddr-gate__promise-note'), copy.offerPromiseNote);
        var lockWrap = gate.querySelector('.ddr-gate__locks');
        if (lockWrap) lockWrap.setAttribute('aria-label', copy.offerLocksLabel || '');
        var locks = gate.querySelectorAll('.ddr-gate__lock strong');
        for (var li = 0; li < locks.length && li < (copy.offerLocks || []).length; li += 1) setText(locks[li], copy.offerLocks[li]);
        setText(gate.querySelector('.ddr-gate__method'), copy.offerMethod);
        var refund = gate.querySelector('.ddr-gate__refund');
        if (refund) refund.remove();
        var note = gate.querySelector('#ddrGateNote,.ddr-gate__note');
        // Set the page's own note once; afterwards keep any status or error the rail writes there.
        if (note && (!offerNoteSet || clean(note.textContent) === offerNoteSet || !clean(note.textContent))) {
          setText(note, root.getAttribute('data-offer-note'));
          offerNoteSet = clean(note.textContent);
        }
        var mini = gate.querySelector('.da-review-mini');
        if (mini) mini.remove();
        if (cartReviewHost && note && note.nextElementSibling !== cartReviewHost) note.insertAdjacentElement('afterend', cartReviewHost);
      }
      if (cta) {
        cta.classList.add('lsc-offer-v2');
        cta.setAttribute('data-lsc-offer-version', 'enterprise-v3');
        setText(cta.querySelector('.ddr-cta__badge'), root.getAttribute('data-offer-eyebrow'));
        setText(cta.querySelector('.ddr-cta__title'), root.getAttribute('data-offer-title'));
        setText(cta.querySelector('.ddr-cta__text'), root.getAttribute('data-offer-lead'));
        setText(cta.querySelector('.ddr-gate__promise-kicker'), copy.offerPromiseKicker);
        setText(cta.querySelector('.ddr-gate__promise-question'), selectedLens && copy.lenses[selectedLens]
          ? fill(copy.offerPromiseQuestion, { sign: currentChart ? currentChart.sign.name : '', lens: copy.lenses[selectedLens].label })
          : fill(copy.curiosityBase, { sign: currentChart ? currentChart.sign.name : '' }));
        setText(cta.querySelector('.ddr-gate__promise-note'), copy.offerPromiseNote);
        setText(cta.querySelector('.ddr-cta__method'), copy.offerMethod);
      }
      updateMobileBuy(gate);
      if (typeof MutationObserver === 'function' && offer) {
        if (!offerObserver) offerObserver = new MutationObserver(decorateOfferSoon);
        offerObserver.observe(offer, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-checked', 'disabled'] });
      }
    }
    function decorateOfferSoon() {
      if (offerTimer !== null) return;
      offerTimer = window.setTimeout(decorateOffer, 0);
    }

    if (cityInput) {
      cityInput.setAttribute('aria-expanded', 'false');
      cityInput.addEventListener('input', function () {
        selectedPlace = null;
        cityInput.removeAttribute('aria-invalid');
        if (q('city-error')) q('city-error').textContent = '';
        if (cityTimer) window.clearTimeout(cityTimer);
        cityTimer = window.setTimeout(searchCity, 280);
      }, { passive: true });
      cityInput.addEventListener('focus', function () {
        if (window.matchMedia && window.matchMedia('(max-width: 720px)').matches) {
          window.setTimeout(function () { scrollTo(cityInput); }, 180);
        }
      }, { passive: true });
      cityInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && suggestions && suggestions.classList.contains('is-open')) {
          var first = suggestions.querySelector('button');
          if (first) { event.preventDefault(); first.click(); }
        } else if (event.key === 'Escape') {
          closeSuggestions();
        }
      });
    }
    document.addEventListener('click', function (event) {
      if (suggestions && cityInput && !suggestions.contains(event.target) && event.target !== cityInput) closeSuggestions();
    }, { passive: true });
    if (dateInput) dateInput.addEventListener('input', function () {
      dateInput.removeAttribute('aria-invalid');
      q('date-error').textContent = '';
    }, { passive: true });
    if (form) form.addEventListener('submit', function (event) { event.preventDefault(); calculate(false); });
    if (timeInput) timeInput.addEventListener('input', function () {
      syncTimeCityRequirement();
      if (!clean(timeInput.value) && !clean(cityInput.value)) {
        cityInput.removeAttribute('aria-invalid');
        q('city-error').textContent = '';
      }
    }, { passive: true });
    for (var l = 0; l < lensButtons.length; l += 1) {
      lensButtons[l].tabIndex = l === 0 ? 0 : -1;
      lensButtons[l].addEventListener('click', function () {
        selectedLens = this.getAttribute('data-lsc-lens') || '';
        for (var i = 0; i < lensButtons.length; i += 1) {
          lensButtons[i].setAttribute('aria-checked', String(lensButtons[i] === this));
          lensButtons[i].tabIndex = lensButtons[i] === this ? 0 : -1;
        }
        q('lens-error').textContent = '';
        currentReflection = null;
        q('reflection').hidden = true;
        if (currentChart) enableOffer(currentChart, selectedLens);
        updateMobileBuy(root.querySelector('#ddrGate'));
        saveSession();
        track('lilith_lens_selected', { lens: selectedLens, sign: currentChart ? currentChart.sign.key.toLowerCase() : '' });
      });
      lensButtons[l].addEventListener('keydown', function (event) {
        var current = Array.prototype.indexOf.call(lensButtons, this);
        var next = current;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % lensButtons.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + lensButtons.length) % lensButtons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = lensButtons.length - 1;
        else return;
        event.preventDefault();
        lensButtons[next].focus();
        lensButtons[next].click();
      });
    }
    if (reflectButton) reflectButton.addEventListener('click', createReflection);
    if (reflectionPaidButton) reflectionPaidButton.addEventListener('click', function () {
      var gate = root.querySelector('#ddrGate');
      try { if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.showGate === 'function') window.DeckauraDeepReading.showGate(false); } catch (_) {}
      scrollTo(gate || q('offer'));
      track('lilith_reflection_paid_handoff', { lens: selectedLens || 'desire' });
    });
    if (editButton) editButton.addEventListener('click', function () {
      restoreFormForEditing(true);
      scrollTo(form);
      window.setTimeout(function () { if (dateInput) dateInput.focus(); }, 260);
      track('lilith_birth_details_edit_started');
    });
    if (againButton) againButton.addEventListener('click', function () {
      restoreFormForEditing(true);
      var image = q('result-image');
      if (image) image.removeAttribute('src');
      var back = q('card-back');
      if (back) back.removeAttribute('src');
      var stage = q('card-stage');
      if (stage) stage.classList.remove('is-front');
      currentChart = null;
      selectedLens = '';
      currentReflection = null;
      clearSession();
      scrollTo(form);
      track('lilith_recalculate_started');
    });
    if (result && typeof IntersectionObserver === 'function') {
      var mobileReveal = root.querySelector('#ddrGateReveal');
      mobileOfferObserver = new IntersectionObserver(function (entries) {
        for (var entryIndex = 0; entryIndex < entries.length; entryIndex += 1) {
          if (entries[entryIndex].target === result) mobileOfferVisible = entries[entryIndex].isIntersecting;
          if (entries[entryIndex].target === mobileReveal) mobileRevealVisible = entries[entryIndex].isIntersecting;
        }
        updateMobileBuy(root.querySelector('#ddrGate'));
      }, { threshold: 0 });
      mobileOfferObserver.observe(result);
      if (mobileReveal) mobileOfferObserver.observe(mobileReveal);
    }
    function revealNode(node) {
      if (!node || !node.getClientRects().length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { node.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (_) { node.scrollIntoView(); }
    }
    function setMobileBusy(busy, holdMs) {
      if (!mobileBuyButton) return;
      if (mobileBusyTimer) { window.clearTimeout(mobileBusyTimer); mobileBusyTimer = null; }
      mobileBuyButton.disabled = !!busy;
      if (busy) {
        mobileBuyButton.setAttribute('aria-busy', 'true');
        mobileBuyButton.textContent = root.getAttribute('data-mobile-busy') || mobileBuyLabel;
        if (holdMs) mobileBusyTimer = window.setTimeout(function () { setMobileBusy(false); }, holdMs);
      } else {
        mobileBuyButton.removeAttribute('aria-busy');
        mobileBuyButton.textContent = mobileBuyLabel;
      }
    }
    var CART_REVIEW_REASON = /^(reading_cart_conflict|cart_changed|cart_operation_busy|cart_result_uncertain|cart_read_failed|cart_add_failed|checkout_guard_unavailable|checkout_navigation_busy)$/;
    /* Checkout started from the bar reports through the rail's hidden detail CTA (#ddrNote).
       Repeat the reason under the visible package button and bring it into view. */
    function showMobileCheckoutFailure(outcome, railNote) {
      setMobileBusy(false);
      var reason = String(outcome && outcome.reason || '');
      if (cartReviewHost && !cartReviewHost.hidden && clean(cartReviewHost.textContent) && CART_REVIEW_REASON.test(reason)) {
        revealNode(cartReviewHost);
        return;
      }
      var message = reason === 'checkout_timeout' ? '' : clean(railNote && railNote.textContent);
      var gateNote = root.querySelector('#ddrGateNote');
      if (gateNote) gateNote.textContent = message || root.getAttribute('data-checkout-retry') || '';
      revealNode(root.querySelector('#ddrGateReveal') || gateNote || q('offer'));
    }
    if (mobileBuyButton) mobileBuyButton.addEventListener('click', function () {
      if (mobileBuyButton.disabled) return;
      var api = window.DeckauraDeepReading;
      var gateReveal = root.querySelector('#ddrGateReveal');
      // A checkout started from the package button is still running: show it rather than start another.
      if (gateReveal && gateReveal.classList.contains('is-loading')) { revealNode(gateReveal); return; }
      var railNote = document.getElementById('ddrNote');
      if (railNote) railNote.textContent = '';
      track('lilith_mobile_checkout_started', { lens: selectedLens || 'desire' });
      if (api && typeof api.checkoutNowAsync === 'function') {
        setMobileBusy(true);
        var pending;
        try { pending = api.checkoutNowAsync(); } catch (_) { pending = null; }
        Promise.resolve(pending).then(function (outcome) {
          if (outcome && outcome.ok === true) setMobileBusy(true, 15000);
          else showMobileCheckoutFailure(outcome || { ok: false, reason: 'checkout_not_started' }, railNote);
        }, function () { showMobileCheckoutFailure({ ok: false, reason: 'checkout_not_started' }, railNote); });
        return;
      }
      setMobileBusy(true, 4000);
      var started = false;
      try {
        if (api && typeof api.checkoutNow === 'function') started = api.checkoutNow() === true;
        else if (gateReveal && !gateReveal.disabled) { gateReveal.click(); started = true; }
      } catch (_) {}
      if (!started) showMobileCheckoutFailure({ ok: false, reason: 'checkout_not_started' }, railNote);
    });
    window.addEventListener('pageshow', function () { setMobileBusy(false); });
    window.addEventListener('resize', function () { updateMobileBuy(root.querySelector('#ddrGate')); }, { passive: true });
    document.addEventListener('deckaura:paid-offer-ready', decorateOfferSoon);
    syncTimeCityRequirement();
    restoreSession();
    root.addEventListener('shopify:block:unload', function () {
      if (mobileOfferObserver) mobileOfferObserver.disconnect();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target || document); });
}());
